import { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function PlusIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 32 32">
      <path
        d="M15 17.667H8.333a1.3 1.3 0 0 1-.95-.384 1.3 1.3 0 0 1-.383-.95q0-.566.383-.95a1.3 1.3 0 0 1 .95-.383H15V8.333q0-.566.383-.95a1.3 1.3 0 0 1 .95-.383q.567 0 .95.383.384.384.384.95V15h6.666q.567 0 .95.383.384.384.384.95 0 .567-.384.95a1.3 1.3 0 0 1-.95.384h-6.666v6.666q0 .567-.384.95a1.3 1.3 0 0 1-.95.384 1.3 1.3 0 0 1-.95-.384 1.3 1.3 0 0 1-.383-.95z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
